import { connect } from "react-redux";

import AppNav from "layout/Navigation/AppNav";
import { selectUserName } from "selector/authSelectors";
import {
  getUserClientName,
  getCurrentExternalId,
  getExternalIds,
  getGhostingCompany
} from "selector/userSelectors";
import types from "actions/actionTypes";

const mapStateToProps = state => {
  return {
    user: {
      name: selectUserName(state),
      client: getUserClientName(state),
      ghostingCompany: getGhostingCompany(state)
    },
    userOffice: {
      current: getCurrentExternalId(state),
      options: getExternalIds(state)
    }
  };
};

const mapDispatchToProps = dispatch => ({
  fetchUserInfo: () => dispatch({ type: types.GET_USER_ATTRIBUTES }),
  setUserOffice: office =>
    dispatch({ type: types.SET_USER_OFFICE, payload: office })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppNav);
